export default function SearchDetails () {
    return (
    <div>

<div className="search-bg bg-image">
            <div className="gap-spacer"></div>
            <div className="page-title top-cap-outlines">
                <script async src="https://cse.google.com/cse.js?cx=b628101330d7a4166">
                </script>

                <h2>Search:</h2>
                <script async src="https://cse.google.com/cse.js?cx=b628101330d7a4166">
                </script>
                <div className="gcse-searchbox"></div>
            </div>
            <div className="content-fluid">

                <div className="mb-960-center-container mid-side-outlines">
                    <div className="gcse-searchresults"></div>
                </div>


            </div>
            <div className="page-footer bottom-cap-outlines">&nbsp;</div>
           


            </div>
            </div>
            )
            }
